import { Card, CardBody, Col, Row } from "reactstrap";
import { EventsCalendar } from "../components/events/EventsCalendar";
import NitroAdSidebar from "../../ads/NitroAdSidebar";
import Calendar from "../components/common/Calendar";
import { useEffect } from "react";
import truckyService from "../../common/services/trucky-service";

export default function EventsCalendarPage({ container }) {
  useEffect(() => {
    truckyService.setDocumentTitle("Events");
  }, []);

  return (
    <Row>
      <Col>
        <EventsCalendar container={container} />
      </Col>
      <div className="ad-column-placeholder">
        {!container.dataService.data.enablePremiumFeature() && (
          <NitroAdSidebar container={container}></NitroAdSidebar>
        )}
      </div>
    </Row>
  );
}
